import { render, staticRenderFns } from "./CopyText.vue?vue&type=template&id=7362d191&"
import script from "./CopyText.vue?vue&type=script&lang=ts&"
export * from "./CopyText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports